/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win5_TInputs */

const en_wc_vs_win5_t = /** @type {(inputs: Wc_Vs_Win5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light and fast`)
};

/**
* | output |
* | --- |
* | "Light and fast" |
*
* @param {Wc_Vs_Win5_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win5_t = /** @type {((inputs?: Wc_Vs_Win5_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win5_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win5_t(inputs)
});
export { wc_vs_win5_t as "wc.vs.win5.t" }